import { Trans, useTranslation } from 'next-i18next'
import { useEffect, useState } from 'react'

import MustKnowTags from '~/statistics-v2/components/MustKnowTags'
import { MustKnowTopicProgress } from '~/statistics-v2/types/statistics.types'

export default function MustKnowPerformanceViewer({
  mustKnowsProgress,
}: {
  mustKnowsProgress: MustKnowTopicProgress[] | undefined
}): React.ReactElement {
  const { t } = useTranslation('statisticsV2')
  const [isMounted, setIsMounted] = useState(false)

  useEffect(() => {
    const timer = setTimeout(() => setIsMounted(true), 50)
    return () => clearTimeout(timer)
  }, [])

  if (!mustKnowsProgress || mustKnowsProgress.length === 0) return <></>

  return (
    <div
      className={`flex flex-col gap-4 h-full transition-all duration-700 ease-out transform ${
        isMounted ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'
      }`}
    >
      <div className="flex lg:items-start items-center flex-col gap-4">
        <span className="text-white text-xs font-black tracking-widest uppercase flex items-center w-full justify-between lg:justify-start">
          {Trans({
            t,
            i18nKey: 'mustKnowsMastered',
            components: { span: <span className="text-blue-pastel text-xs font-bold uppercase ml-auto" /> },
            children: t('mustKnowsMastered'),
            values: {
              mastered: mustKnowsProgress.filter((mk) => mk.isCompleted).length,
              total: mustKnowsProgress.length,
            },
          })}
        </span>
      </div>
      <div className="flex flex-wrap lg:items-start items-center justify-center lg:flex-row flex-col gap-2 h-full">
        {mustKnowsProgress.map((mustKnow) => {
          const isCompleted = mustKnow.isCompleted
          return <MustKnowTags isSelected={isCompleted} key={`${mustKnow.title}`} title={mustKnow.title} />
        })}
      </div>
    </div>
  )
}
